import {
  ResumeIntakeEvent,
  TrackedResumeIntakeEvent,
} from "../_types/resumeIntake";
import { useResumeIntakeTranscriptStore } from "../_stores/resumeIntakeTranscriptStore";

type LegacyMessage = {
  type: string;
  content?: string;
};

export const recordLegacyMessage = (message: LegacyMessage) => {
  if (!message.content) return;

  const transcriptStore = useResumeIntakeTranscriptStore.getState();
  if (message.type === "ai") {
    transcriptStore.appendAssistantMessage(message.content, "legacy-chat");
  }

  if (message.type === "user") {
    transcriptStore.appendUserMessage(message.content, "legacy-chat");
  }
};

export const recordLegacyMessages = (messages: LegacyMessage[]) => {
  messages.forEach(recordLegacyMessage);
};

export const recordLegacyEvent = (event: ResumeIntakeEvent) => {
  useResumeIntakeTranscriptStore.getState().appendEvent(event, "legacy-chat");
};

export const recordLegacyStateUpdate = (path: string, value: unknown) => {
  useResumeIntakeTranscriptStore.getState().trackStateUpdated(path, value, "legacy-chat");
};

export const recordLegacyToolStarted = (name: string) => {
  useResumeIntakeTranscriptStore.getState().trackToolStarted(name, "legacy-chat");
};

export const recordLegacyToolFinished = (name: string) => {
  useResumeIntakeTranscriptStore.getState().trackToolFinished(name, "legacy-chat");
};

export const replaceLegacyTranscript = (events: TrackedResumeIntakeEvent[]) => {
  useResumeIntakeTranscriptStore.getState().replaceEvents(events);
};

